import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import CustomDropDown from '../../common/dropdown/CustomDropDown';
import * as messageAlert from '../../../actions/messageAlertAction';
import * as bookActions from '../../../actions/bookActions';
import { ROLE, ROUTES } from '../../../const';
import CustomBookCard from '../../common/CustomBookCard';
import * as optionItemsFactory from '../../../factory/optionItemsFactory';
import * as drawerActions from '../../../actions/drawerActions';
import { ANALYTICS_CONTEXT } from '../../../types/analytics';

class BookCardCommon extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleBookVisibility = this.handleBookVisibility.bind(this);
    this.handleRemoveBook = this.handleRemoveBook.bind(this);
    this.handleCopyBook = this.handleCopyBook.bind(this);
    this.renderOptions = this.renderOptions.bind(this);
  }

  static propTypes = {
    book: PropTypes.object,
    isAppOnline: PropTypes.any,
    bookActions: PropTypes.object,
    classroom: PropTypes.string,
    configuration: PropTypes.object,
    user: PropTypes.object,
    extraMenuOptions: PropTypes.array,
    renderLoadBar: PropTypes.func,
    renderSavedBookIcon: PropTypes.object
  };

  handleRemoveBook() {
    const { isAppOnline } = this.props;

    if (isAppOnline) {
      const { bookActions, book } = this.props;
      bookActions.setRemoveBookState(book);
    }
  }

  handleCopyBook() {
    const { isAppOnline } = this.props;

    if (isAppOnline) {
      const { bookActions, book } = this.props;
      let copyReveal = { activityId: book.activityId };
      bookActions.setCopyRevealData(copyReveal);
    }
  }

  handleBookVisibility() {
    const { isAppOnline } = this.props;

    if (isAppOnline) {
      const { bookActions, book, classroom } = this.props;

      let activityId = book.activityId;
      let bookId = book.id;

      if (book.disabled) {
        bookActions.enableBookLevel(classroom, bookId, activityId, ANALYTICS_CONTEXT.BOOK_SHOW);
      } else {
        bookActions.disableBookLevel(classroom, bookId, activityId, ANALYTICS_CONTEXT.BOOK_HIDE);
      }
    }
  }

  getOptionItems(extraMenuOptions) {
    const { role } = this.props;

    const isInstructor = role === ROLE.INSTRUCTOR;
    let optionItems = isInstructor ? this.getTeacherOptions() : [];
    if (extraMenuOptions) {
      extraMenuOptions.forEach(o => {
        optionItems.splice(o.position, 0, o.option);
      });
    }
    return optionItems;
  }

  getTeacherOptions() {
    const { book, configuration } = this.props;
    let visibilityText = book.disabled ? I18n.t('common.option.show') : I18n.t('common.option.hide');
    let visibilityIcon = book.disabled ? 'eye-view' : 'no-eye-view';

    let options = [];

    if (configuration.authoring && configuration.importContentInClassroom) {
      options.push(optionItemsFactory.getVisibilityItem(visibilityText, visibilityIcon, this.handleBookVisibility));
      options.push(optionItemsFactory.getDeleteItem(this.handleRemoveBook));
      if (configuration.copyBook && configuration.importContentInClassroom) {
        options.push(optionItemsFactory.getCopyItem(this.handleCopyBook));
      }
    }
    return options;
  }

  renderEmptyLoadBar() {
    // Exists only because it is required by CardLarge to receive a renderLoadBar function
    return;
  }

  static renderSavedBookIconEmpty() {}

  renderOptions() {
    const { book, extraMenuOptions } = this.props;

    let optionItems = this.getOptionItems(extraMenuOptions);

    if (optionItems.length > 0) {
      return <CustomDropDown id={book.id} optionItems={optionItems} lightIconColor={true} />;
    }
    return <div />;
  }

  render() {
    const { book, classroom, renderLoadBar, renderSavedBookIcon } = this.props;
    const renderLoadBarFinal = renderLoadBar || this.renderEmptyLoadBar;

    return (
      <CustomBookCard
        goToUrl={`${ROUTES.CLASSROOM}/${classroom}/book/${book.id}`}
        classroom={classroom}
        book={book}
        bookOptions={this.renderOptions()}
        renderLoadBar={renderLoadBarFinal}
        renderSavedBookIcon={renderSavedBookIcon}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    role: state.classrooms.selectedClassroom.classroom.role,
    user: state.account.user,
    i18n: state.i18n,
    isAppOnline: state.connection.status.online,
    configuration: state.account.configuration
  };
}

function mapDispatchToProps(dispatch) {
  return {
    bookActions: bindActionCreators(bookActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch),
    drawerActions: bindActionCreators(drawerActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BookCardCommon);
